module.exports = __webpack_public_path__ + "static/media/download.c8df3ffc.svg";